import React from 'react'

const Footer = () => {
  return (
    <div class="container-fluid bg-dark text-light footer pt-5 wow fadeIn" data-wow-delay="0.1s" >
    {/* style="margin-top: 6rem;" */}
        <div class="container py-5">
            <div class="row g-5">
                <div class="col-lg-3 col-md-6">
                    <h4 class="text-light mb-4">Address</h4>
                    <p class="mb-2"><i class="fa fa-map-marker-alt me-3"></i>1206, Sector-7, Bahadurgarh, Haryana 124507. </p>
                    <p class="mb-2"><i class="fa fa-phone-alt me-3"></i>+91 8368771407</p>
                    <p class="mb-2"><i class="fa fa-envelope me-3"></i>gmbd@rsindustrialsolutions.net</p>
                    {/* <div class="d-flex pt-2">
                        <a class="btn btn-outline-light btn-social" href=""><i class="fab fa-twitter"></i></a>
                        <a class="btn btn-outline-light btn-social" href=""><i class="fab fa-facebook-f"></i></a>
                        <a class="btn btn-outline-light btn-social" href=""><i class="fab fa-youtube"></i></a>
                        <a class="btn btn-outline-light btn-social" href=""><i class="fab fa-linkedin-in"></i></a>
                    </div> */}
                </div>
                <div class="col-lg-3 col-md-6">
                    <h4 class="text-light mb-4">Industries</h4>
                    <a class="btn btn-link" href="/industries#automotive">Automotive</a>
<a class="btn btn-link" href="/industries#food-industry">Food Industry</a>
<a class="btn btn-link" href="/industries#tyre-industry">Tyre Industry</a>
<a class="btn btn-link" href="/industries#machine-tool-industry">Machine Tool Industry</a>
<a class="btn btn-link" href="/industries#mining">Mining</a>
<a class="btn btn-link" href="/industries#oil-gas">Oil & Gas</a>

                </div>
                <div class="col-lg-3 col-md-6">
                    <h4 class="text-light mb-4">Quick Links</h4>
                    <a class="btn btn-link" href="/">Home</a>
                    <a class="btn btn-link" href="/about">About Us</a>
                    <a class="btn btn-link" href="/products">Products</a>
                    <a class="btn btn-link" href="/industries">Industries</a>
                    <a class="btn btn-link" href="/contact">Contact us</a>
                </div>
                <div class="col-lg-3 col-md-6">
                    <h4 class="text-light mb-4">Newsletter</h4>
                    <p>Stay updated with our latest industrial solutions, quality tools, and expert services. Subscribe now!</p>
                    <div class="position-relative mx-auto" >
                    {/* style="max-width: 400px;" */}
                        <input class="form-control border-0 w-100 py-3 ps-4 pe-5" type="text" placeholder="Your email" />
                        <button type="button" class="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2">SignUp</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="copyright">
                <div class="row">
                    <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
                        &copy; <a class="border-bottom" href="#">Rsis</a>, All Right Reserved.
                    </div>
                    <div class="col-md-6 text-center text-md-end">
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Footer